import { BuildNode, NodeStates, ProductVariationsNode } from "../../build/types";
import { useInteractionStates } from "../../hooks/useInteractionStates";
import { getCompoundStyle, getStateStyleForBuilder, getStylesFromInteractiveStates } from "../helpers";

interface VariationOptionProps {
    node: BuildNode;
    name: string;
    option: {
        label: string;
        value: string;
        price?: string;
        checked?: boolean;
        isAvailable?: boolean;
    };
    formatC: (amount: number) => string;
    onSelect?: (value: { value: string; name: string }) => void;
    builder?: boolean;
    nodeState?: NodeStates;
    disabled?: boolean;
}

const VariationOption = ({ node, name, option, formatC, onSelect, builder, nodeState, disabled }: VariationOptionProps) => {
    const { setElement, states } = useInteractionStates<HTMLLabelElement>();
    const pVarNode = node as ProductVariationsNode;
    const { stateManager, inputStyles } = pVarNode;

    if (builder) {
        const inputStylesWithState = getCompoundStyle({
            otherStyle: inputStyles,
            stateStyle: getStateStyleForBuilder(stateManager, nodeState, "inputStyles")
        });

        const { color, fontSize, fontWeight, ...rest } = inputStylesWithState;

        return (
            <label htmlFor={option.value}>
                <input type="radio" id={option.value} value={option.value} name={name} checked={option.checked} readOnly={true} />
                <div className="custom-radio" style={rest}>
                    <p
                        style={{
                            color,
                            fontSize,
                            fontWeight
                        }}
                    >
                        {option.label + (pVarNode.showPrices && option.price ? ` (${formatC(parseFloat(option.price))})` : "")}
                    </p>
                </div>
            </label>
        );
    } else {
        const extraStates = (
            disabled || option.checked
                ? [option.checked && NodeStates.SELECTED, disabled && NodeStates.DISABLED].filter(Boolean)
                : undefined
        ) as NodeStates[];

        const inputStylesWithState = getStylesFromInteractiveStates({
            states,
            defaultStyle: inputStyles,
            stateManager,
            paths: ["inputStyles"],
            extraStates
        });

        const { color, fontSize, fontWeight, ...rest } = inputStylesWithState;

        return (
            <label htmlFor={option.value} ref={setElement}>
                <input
                    type="radio"
                    id={option.value}
                    value={option.value}
                    name={name}
                    checked={option.checked}
                    readOnly={false}
                    onChange={() => onSelect && onSelect({ value: option.value, name })}
                    disabled={disabled}
                />
                <div className="custom-radio" style={rest}>
                    <p
                        style={{
                            ...{ color, fontSize, fontWeight },
                            ...(option.isAvailable ? { opacity: 1 } : { opacity: 0.5 })
                        }}
                    >
                        {option.label + (pVarNode.showPrices && option.price ? ` (${formatC(parseFloat(option.price))})` : "")}
                    </p>
                </div>
            </label>
        );
    }
};

export default VariationOption;
